import React, { useEffect, useState, useCallback } from 'react';
import SoundManager from "../../../SoundManager";
import './ReactCaption.css';

const ReactCaption = (obj: any) => {
	useEffect(() => {
	}, [obj]);

	const [closedCaptions, setClosedCaptions] = useState(SoundManager.hiddenCaption);

	const closedCaptionsCallback = useCallback(
		() => {
			setClosedCaptions((closedCaptions: boolean) => !closedCaptions);
		},
		[obj],
	);


	const onChangeValueKeyboard = (e: any) => {
		if (e.keyCode == 32 || e.keyCode == 13) { //32 - spacebar, 36 - enter
			closedCaptionsCallback();
		}
	};

	var renderCaption = () => {
		return (
			<>
				<div className="captions-icon"
					aria-label="Toggle Captions"
					role="button"
					tabIndex={0}
					onClick={closedCaptionsCallback}
					onKeyDown={onChangeValueKeyboard}>
					<img src={closedCaptions ? './assets/img/closed-captioning-off.png' : './assets/img/closed-captioning-on.png'} />
				</div>
				{obj.currentCaption && <div className="caption-container">
					{!closedCaptions &&
						<div className="caption-block">
							<p className="caption-paragraph">
								{obj.currentCaption}
							</p>
						</div>
					}
				</div>
				}
			</>
		);
	};

	return (
		<>
			{renderCaption()}
		</>
	);
};

export default ReactCaption;